import { Typography } from "@mui/material";
import React from "react";

import QuotaDefinitionApproval from "./QuotaDefinitionApproval";
import NormalModification from "./NormalModification";
import ShiftModification from "./ShiftModification";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function ApprovalLevels() {
  return (
    <>
      <CollapseSection title=" Quota Definition Approval">
        <br />
        <QuotaDefinitionApproval />
      </CollapseSection>
      <CollapseSection title="Quota Modification Approval">
        <br />
        <NormalModification />
        <ShiftModification />
      </CollapseSection>
    </>
  );
}
